exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-a > a:hover {\n  background: #04a4a4 !important; }\n\n.name-a > a:visited {\n  background: #04a4a4 !important; }\n\n.nav .open > a, .nav .open > a:hover, .nav .open > a:focus {\n  background: #04a4a4 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-top/index-top.component.scss
// module id = ../../../../../ng-src/app/module/index-operation/index/index-top/index-top.component.scss
// module chunks = main